import styled, { keyframes } from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { transparentize } from 'polished';

export const Divider = styled.hr`
  background-color: ${themeGet('colors.black.10')};
  margin: 7px 0;
`;

const shimmer = keyframes`
  0% {
    background-position: -600px 0;
  }
  100% {
    background-position: 600px 0;
  }
`;

export const TextPlaceholder = styled.div`
  height: 18px;
  border-radius: 8px;
  width: ${props => props.width};
  margin: ${props => props.margin};
  animation: ${shimmer} 1.5s infinite;
  ${props =>
    props.isLoading
      ? `
    background: linear-gradient(
      to right,
      ${transparentize(0.2, themeGet('colors.primary.80')(props))} 4%,
      ${transparentize(0.4, themeGet('colors.primary.80')(props))} 25%,
      ${transparentize(0.6, themeGet('colors.primary.80')(props))} 36%
    );
  `
      : `background: ${transparentize(
          0.6,
          themeGet('colors.primary.80')(props),
        )};`}
  background-size: 1000px 100%;
`;

export const PlaceholderGroup = styled.div`
  display: flex;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.marginBottom};
`;
